"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCirrusStoreGetFunction = void 0;
const react_cirrus_1 = require("@yanzi/react-cirrus");
const react_1 = require("react");
const useCirrusStoreGet_1 = require("./useCirrusStoreGet");
function useCirrusStoreGetFunction(urlPrefix = '', contentType = 'application/json') {
    const { socket } = react_cirrus_1.useCirrus();
    return react_1.useCallback((url) => {
        const fullUrl = `${urlPrefix !== null && urlPrefix !== void 0 ? urlPrefix : ''}${url}`;
        if (!fullUrl.match(/^yanzi:\/\//)) {
            throw new Error('Invalid URL given to useCirrusStoreGetFunction');
        }
        return new Promise((resolve, reject) => {
            socket
                .storeGetRequest({
                messageType: 'StoreGetRequest',
                url: fullUrl,
            })
                .next()
                .then(({ value, done }) => {
                if (!done) {
                    useCirrusStoreGet_1.extractData(value, contentType)
                        .then(resolve)
                        .catch(reject);
                }
                else {
                    throw new Error('Socket returned unexpected result');
                }
            })
                .catch(reject);
        });
    }, [socket, urlPrefix, contentType]);
}
exports.useCirrusStoreGetFunction = useCirrusStoreGetFunction;
//# sourceMappingURL=useCirrusStoreGetFunction.js.map